import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { FavoriteToggle } from '../components/FavoriteToggle'

export default connect(
  createStructuredSelector<ApplicationState, ICurrentUserState>({
    user: selectCurrentUser(),
  }),
)(FavoriteToggle)
